// extracted by mini-css-extract-plugin
module.exports = {"form-b-wizard-next":"style_form-b-wizard-next__e7Mw6"};